var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51005 12.8333L0.0742188 10.3975L2.51005 7.96149L3.21272 8.68466L1.99989 9.89749H9.17672V7.23082H10.1767V10.8973H1.99989L3.21272 12.1102L2.51005 12.8333ZM1.30505 5.76916V2.10266H9.48188L8.26905 0.889823L8.97172 0.166656L11.4076 2.60249L8.97172 5.03849L8.26905 4.31532L9.48188 3.10249H2.30505V5.76916H1.30505Z",
    fill: "#3A4750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSets);
export default __webpack_public_path__ + "static/media/sets.508a8e4e937d174a938e4887131c1290.svg";
export { ForwardRef as ReactComponent };